module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc( "UserNewAccount", "This is now your new username" ) ))==null?'':__t)+
'</legend></fieldset><fieldset><label for="new-account-username-input">'+
((__t=( i18n.tc( "UserNewAccount", "Username:" ) ))==null?'':__t)+
'</label> <input type="text" id="new-account-username-input" name="new-account-username-input" data-input="new-account-username" value="'+
((__t=( email ))==null?'':__t)+
'" disabled="disabled"></fieldset><fieldset><p class="static">'+
((__t=( i18n.tc( "UserNewAccount", "Based on your existing information, we've chosen a username for you. You can change the username when the update is completed." ) ))==null?'':__t)+
'</p></fieldset><fieldset class="button-wrap"><button class="primary" data-click="new-account-accept">'+
((__t=( i18n.tc("UserNewAccount", "Continue") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
